import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'httpUrl'
})
export class HttpUrlPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let http_url_reg = new RegExp(/^[http | https]/i);
    if (!http_url_reg.test(value)) {
      return 'http://' + value;
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/pipe/http-url.pipe.ts